/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-08-24",
    versionChannel: "nightly",
    buildDate: "2023-08-24T00:20:48.719Z",
    commitHash: "1b03ce9ae668ea2b40f03f24ad38af95d1e92e80",
};
